<template>
  <el-dialog fullscreen :visible="isShow" :modal="false" :show-close="false" custom-class="dialog-form">
    <div slot="title" class="dialog-title-container">
      <span class="title-label"><i class="el-icon-document"></i> 部门表单</span>
      <i class="el-icon-error" @click="close"></i>
    </div>
    <el-row class="form-top-btns">
      <template v-if="formData.creater_id === operator_id || editable === '是'">
        <el-button v-if="!formStatus && formData.id !== '0'" type="primary" size="mini" plain round icon="em-icon-edit" @click="editMainHandler"> 编辑</el-button>
        <el-button v-if="formStatus && formData.id !== '0'" type="info" size="mini" plain round icon="em-icon-edit" @click="editMainHandler"> 取消编辑</el-button>
        <el-button v-if="formStatus" type="primary" size="mini" plain round icon="em-icon-save" @click="saveHandler"> 提交保存</el-button>
      </template>
      <el-button type="danger" size="mini" plain round icon="el-icon-close" @click="close">关闭</el-button>
    </el-row>
    <div class="form-container">
      <el-form ref="form" :model="formData" size="mini" label-width="80px">
        <div class="form-main">
          <el-row>
            <el-col :span="6">
              <el-form-item label="所属部门" prop="name">
                <el-tree-select v-if="formStatus" ref="treeSelect" :value="formData.parent_id" :label="parentDepartmentName" :options="parentDepartments" :props="treeSelectProps" @getValue="getParentValue($event)"></el-tree-select>
                <span v-else>{{formData.parent_name}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="部门名称" prop="name" required>
                <el-input v-if="formStatus" placeholder="部门名称" v-model="formData.name"></el-input>
                <span v-else>{{formData.name}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input v-if="formStatus" placeholder="备注" v-model="formData.remark"></el-input>
                <span v-else>{{formData.remark}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="detail-header">
          <div class="detail-title"><i class="em-icon-th-list"></i> 部门成员信息</div>
          <el-button-group v-if="formStatus">
            <el-button type="success" size="mini" icon="em-icon-plus" @click="showEmployeeDialogHandler"> 添加部门成员</el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="viewDelDetail">删除部门成员</el-button>
          </el-button-group>
        </div>
        <div class="el-table-container form-details" style="top: 66px;">
          <el-table :data="formData.employees" size="mini" height="100%" style="width: 100%; border:1px solid #d1d1d1;" border header-row-class-name="list-header-row" row-class-name="list-row" @selection-change="handleSelectionChange">
            <el-table-column v-if="formStatus" type="selection" width="50" align="center"></el-table-column>
            <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
            <el-table-column label="员工姓名" prop="employee_name" width="100" align="center"></el-table-column>
            <el-table-column label="员工号" prop="employee_code" width="100" align="center"></el-table-column>
            <el-table-column label="性别" prop="sex" width="80" align="center"></el-table-column>
            <el-table-column label="身份证号" prop="card_no" width="200" align="center"></el-table-column>
            <el-table-column label="联系电话" prop="phone" width="200" align="center"></el-table-column>
            <el-table-column label="电子邮箱" prop="email" width="300" align="center"></el-table-column>
            <el-table-column label="兼职人员" prop="is_part_timer" width="80" align="center"></el-table-column>
            <el-table-column label="是负责人" width="100" align="center">
              <template v-slot:default="item">
                <el-select v-if="formStatus" size="mini" v-model="item.row.is_leader" placeholder="请选择">
                  <el-option v-for="(u, index) in yesOrNo" :key="index" :label="u.label" :value="u.label"></el-option>
                </el-select>
                <span v-else>{{item.row.is_leader}}</span>
              </template>
            </el-table-column>
            <el-table-column label="备注" align="center">
              <template v-slot:default="item">
                <el-input v-if="formStatus" size="mini" placeholder="备注" v-model="item.row.remark"></el-input>
                <span v-else>{{item.row.remark}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <div class="form-footer">
        <span>制单人：{{formData.creater_name}}</span>
        <span>制单日期：{{formData.create_time}}</span>
      </div>
    </div>
    <!-- 选择员工对话框 -->
    <ezz-dialog-employee ref="employeeDialog" width="500px" :parent="this"></ezz-dialog-employee>
  </el-dialog>
</template>
<script>
import EzzDialogEmployee from '@/views/dialogs/CheckMoreEmployees.vue'
import ElTreeSelect from '@/components/tree-select/el-tree-select.vue'

export default {
  name: 'EzzDialogForm',
  props: {
    parent: {
      type: Object,
      default: () => null
    }
  },
  data: function () {
    return {
      // 当前子组件对话框的显隐
      isShow: false,
      formData: null,
      formEmptyData: {
        id: '0',
        parent_id: '',
        parent_name: '一级部门',
        name: '',
        sort: '',
        remark: '',
        creater_name: sessionStorage.getItem('operator'),
        creater_id: '',
        create_time: '',
        employees: []
      },
      formDetailEmptyData: {
        id: '0',
        department_id: '',
        employee_id: '',
        employee_name: '',
        employee_code: '',
        sex: '',
        card_no: '',
        phone: '',
        email: '',
        is_part_timer: '',
        is_leader: '否',
        remark: ''
      },
      operator_id: sessionStorage.getItem('operator_id'),
      parentDepartments: [],
      // 是否是负责人
      yesOrNo: [
        { label: '是' },
        { label: '否' }
      ],
      selectedEmployees: [],
      parentDepartmentName: '一级部门',
      treeSelectProps: {
        // 配置项（必选）
        value: 'id',
        label: 'name',
        children: 'children'
      },
      formStatus: false,
      detailCurrentRowIndex: 0,
      editable: this.$store.state.editable,
      delable: this.$store.state.delable
    }
  },
  created: function () {
    this.formData = JSON.parse(JSON.stringify(this.formEmptyData))
  },
  mounted: function () {
  },
  methods: {
    loadData: function () {
      let _this = this
      _this.post(_this.$apis.getDepartment, { ModelId: _this.formData.id }, function (res) {
        let _json = res.data
        let _formData = _json.department
        if (_formData != null) {
          _this.formData = _formData
          _this.formData.employees = _json.employees
        } else {
          _this.formData = JSON.parse(JSON.stringify(_this.formEmptyData))
          _this.formData.creater_id = _this.operator_id
        }
        _this.parentDepartments = [{ id: '', name: '一级部门' }].concat(_json.parentDepartments)
      })
    },
    close: function () {
      this.$confirm('确定关闭？', '提示', {})
        .then(_ => {
          this.isShow = false
        })
        .catch(_ => {
          return false
        })
    },
    addHandler: function () {
      this.formData.id = '0'
      this.isShow = true
      this.formStatus = true
      this.loadData()
    },
    viewHandler: function (formId) {
      this.formData.id = formId
      this.loadData()
      this.isShow = true
      this.formStatus = false
    },
    editMainHandler: function () {
      this.formStatus = !this.formStatus
    },
    delDetail: function (_index) {
      let _this = this
      _this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$delete(_this.formData.employees, _index)
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 删除联系人明细
    viewDelDetail: function () {
      let _this = this
      if (_this.selectedEmployees.length > 0) {
        _this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // ajax提交至服务器，删除数据
          let _delEmployeeIds = []
          _this.selectedEmployees.forEach(item => {
            _delEmployeeIds.push(item.employee_id)
          })
          _delEmployeeIds.forEach((item) => {
            _this.formData.employees.splice(_this.formData.employees.findIndex(v => v.employee_id === item), 1)
          })

          console.log(_this.formData)
        }).catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      } else {
        _this.$message({
          message: '至少选择一条数据',
          type: 'warning'
        })
      }
    },
    handleSelectionChange: function (_selection) {
      this.selectedEmployees = _selection
    },
    // 表单验证，_mainData是主表数据，_detailData从表数据，如果只验证从表数据，_mainData要设置为null
    validationHandler: function (_mainData) {
      let _this = this
      if (_mainData !== null) {
        if (_mainData.name === '') {
          _this.$message({
            type: 'error',
            message: '部门名称不能为空'
          })
          return false
        }
      }
      return true
    },
    // 新增时主从表同时保存
    saveHandler: function () {
      let _this = this
      if (_this.validationHandler(_this.formData)) {
        _this.formData.operator_id = _this.operator_id
        _this.post(_this.$apis.saveDepartment, _this.formData, function (res) {
          let _json = res.data
          if (_json.status === 'ok') {
            _this.$message({
              message: '保存成功',
              type: 'success'
            })
            _this.formData.id = _json.id
            _this.formStatus = false
            _this.parent.loadData()
          }
        })
      }
    },
    // 打开明细中对应人选择对话框
    showEmployeeDialogHandler: function () {
      this.$refs.employeeDialog.open(this.formData.employees)
    },
    getParentValue: function (value) {
      this.formData.parent_id = value
    }
  },
  components: {
    EzzDialogEmployee,
    ElTreeSelect
  }
}
</script>
